/* ATN CyberMall — Section 03 Showrooms: arrows slider (no drag, links safe) */
(function () {
  function initSR(root) {
    if (!root || root.__srInit) return;
    root.__srInit = true;

    var strip = root.querySelector('[data-sr-strip]');
    var prev = root.querySelector('[data-sr-prev]');
    var next = root.querySelector('[data-sr-next]');
    if (!strip) return;

    function step() {
      var card = strip.querySelector('.atn-cm-sr-card');
      var gap = parseInt(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap, 10) || 18;
      var w = card ? card.getBoundingClientRect().width : 280;
      return w + gap;
    }

    function update() {
      var overflow = strip.scrollWidth > strip.clientWidth + 4;
      root.classList.toggle('has-overflow', overflow);
      if (prev) prev.disabled = strip.scrollLeft <= 2;
      if (next) next.disabled = !overflow || strip.scrollLeft >= (strip.scrollWidth - strip.clientWidth - 2);
    }

    if (prev) prev.addEventListener('click', function () {
      strip.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      strip.scrollBy({ left: step(), behavior: 'smooth' });
    });

    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(strip);
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sr-root]');
    for (var i = 0; i < roots.length; i++) initSR(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sr-root]');
    if (r) initSR(r);
  });
})();